import { IRichTextCard } from './types';

export const mapRichTextCard = ({ prismicContent }): IRichTextCard => {
  return {
    text: prismicContent.primary.text,
    anchorTargetId: prismicContent.primary.anchor_target_id,
  };
};
